module.exports = __webpack_public_path__ + "static/apple-touch-icon-ea061e43089262dc1a7e8f0d342bdb01.png";